module.exports = __webpack_public_path__ + "img/mastercard.d477dd54.png";